import Vue from "vue";

Vue.filter("toCurrency", function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR"
    });
    return formatter.format(value);
});

Vue.filter("titleCase", function (value) {
    if (!value) return "";
    value = value
        .toLowerCase()
        .replace("-", " ")
        .split(" ");
    for (var i = 0; i < value.length; i++) {
        value[i] = value[i].charAt(0).toUpperCase() + value[i].slice(1);
    }
    return value.join(" ");
});
